import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../../sensorconfig.axios";

interface EventListState {
  eventList: {
    load: boolean;
    data: [];
  };
}

export const eventListSlice = createSlice({
  name: "eventList",
  initialState: {
    eventList: {
      load: false,
      data: [],
    },
  } as EventListState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchEventList.pending, (state: EventListState) => {
        state.eventList.load = true;
      })
      .addCase(
        fetchEventList.fulfilled,
        (state: EventListState, action: any) => {
          state.eventList.data = action.payload;
          state.eventList.load = false;
        }
      )
      .addCase(fetchEventList.rejected, (state: EventListState) => {
        state.eventList.load = false;
      });
  },
});

export default eventListSlice.reducer;

export const fetchEventList = createAsyncThunk(
  "eventList/fetchEventList",
  async (param: any, thunkAPI) => {
    try {
      const queryParams = [];

      if (param.apiParam.warehouse_id) {
        queryParams.push(`warehouse_id=${param.apiParam.warehouse_id}`);
      }
      if (param.apiParam.mhe_id) {
        queryParams.push(`mhe_id=${param.apiParam.mhe_id}`);
      }
      if (param.apiParam.event_type) {
        queryParams.push(`event_type=${param.apiParam.event_type}`);
      }
      if (param.apiParam.per_page) {
        queryParams.push(`per_page=${param.apiParam.per_page}`);
      }
      if (param.apiParam.page) {
        queryParams.push(`current_page=${param.apiParam.page}`);
      }
      if (param.apiParam.search) {
        queryParams.push(`search=${encodeURIComponent(param.apiParam.search)}`);
      }
      if (param.apiParam.date_time_from) {
        queryParams.push(
          `date_time_from=${encodeURIComponent(param.apiParam.date_time_from)}`
        );
      }
      if (param.apiParam.date_time_to) {
        queryParams.push(
          `date_time_to=${encodeURIComponent(param.apiParam.date_time_to)}`
        );
      }
      if (param.apiParam.severity) {
        queryParams.push(`severity=${param.apiParam.severity}`);
      }

      const queryString = queryParams.join("&");

      const { data } = await DataServer.get(
        `/api/management/mheMonitor/v1/getImpactsList?${queryString}`
      );

      return data.data;
    } catch (error) {}
  }
);
